import React from 'react';
import styled from 'styled-components';
import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';

export default function DayReasonInput(props) {
  const { value, setValue } = props;
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  function handleChange(e) {
		setValue(e.target.value);
  }

  function handleFocus() {
    
  }

  function handleBlur() {
    
  }

  return (
    <TopLevelWrapper>
      <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText}>연장 사유</Text>
      <Input 
        // ref={InputRef}
        placeholder='연장 사유를 적어주세요'
        value={value || ''}
        onFocus={handleFocus}
        onChange={handleChange}
        onBlur={handleBlur}/>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;
`;

const Input = styled.textarea`
  width: 212px;
  height: 52px;

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  margin-top: 8px;
  padding: 8px 12px 8px 12px;

  border: 1px solid ${props => props.theme.line};
  border-radius: 8px;
  outline: none;

  color: ${props => props.theme.text};
  background-color: ${props => props.theme.subBackground};

  resize: none;

  &::placeholder {
    color: ${props => props.theme.subText};
  }
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;
`;